import ImmutableRenderComponent from './immutable-render-component';
import QuestionEntryBox from './question-entry-box.jsx';
import QuestionSelector from './question-selector.jsx';

import React from 'react';

/**
 * Represents the Home Page which displays Sample Questions, 
 * and the textbox to enter a custom question at the bottom.
 * It will get the ConfigStore in its properties from the main
 * (AristoDemo) component.
 */
export default class HomePage extends ImmutableRenderComponent {
  constructor(props) {
    super(props);

    // Set the passed question for display in the text input area.
    // This is so the page "remembers" the last asked question.    
    this.state = { question: this.props.query.question };

    this.onQuestionSelected = this.onQuestionSelected.bind(this);
  }

  componentDidMount() {
    if (this.props.query.question) {
      // Scroll down to the input box if the user is returning to the home page (question query param defined)
      setTimeout(() => {
        document.getElementById('question-box').scrollIntoView();
      });
    }
  }

  /**
   * Callback called by the QuestionSelector to populate the textarea
   * with the selected question.
   * "this", when called, will be bound to this object (the HomePage), which
   * will be passed as a parameter to QuestionSelector.
   */
  onQuestionSelected(question) {
    if (question) {
      this.setState({ question });
    }
  }

  render() {
    const hostname = window.location.hostname;
    const internalMode = (hostname === "aristo-demo-internal.allenai.org") ||
        (hostname === "demo.aristo.dev.ai2");
    return (
      <div className="aristo">
        <QuestionSelector
          questions={this.props.featuredQuestions}
          onQuestionClicked={this.onQuestionSelected}
          internalMode={internalMode}/>
        {internalMode ? <QuestionEntryBox question={this.state.question} /> : null}
      </div>
  );
  }
}
